import React from "react";
import SingleReview from "./SingleReview";

const ReviewList = ({ reviews }) => {
    return (
        <div className="review-list">
            {reviews.map((review, index) => (
                <div 
                    key={index} 
                    className={`reveal delay-${(index % 2) + 1}`} // Редува delay-1 и delay-2 за двете колони
                >
                    <SingleReview review={review} />
                </div>
            ))}
        </div>
    );
};

export default ReviewList;

/*
import React from 'react';
import SingleReview from './SingleReview';

const ReviewList = ({ reviews }) => {
  return (
    <div className="review-list">
      {reviews.map((review, index) => (
        <SingleReview key={index} review={review} />
      ))}
    </div>
  );
};

export default ReviewList;
*/